<template>
  <div class="vipsignsuccess">
    <div class="success">
      <div class="img"><i class="iconfont iconxingzhuang22"></i></div>
      <div class="successtext">签名成功</div>
    </div>
    <button class="btn" @click="goBack">返回上一页</button>
  </div>
</template>

<script>
export default {
  name: 'mySignSuccess',
  methods: {
    goBack(){
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="less" scoped>
.vipsignsuccess {
  width: 100%;
  padding: 100px 30px 0;
  .success {
    text-align: center;
    .img{
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      background: #06AE56;
      border-radius: 30px;
      margin: 0 auto;
      .iconfont{
        color: #ffffff;
        font-size: 20px;
      }
    }
    .successtext{
      font-size: 24px;
      line-height: 24px;
      color: #333333;
      margin-top: 20px;
      font-weight: bold;
    }
  }
  .btn{
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #9CC6FF;
    font-size: 16px;
    font-weight: 400;
    color: #398DFF;
    background: none;
    margin-top: 200px;
  }
}
</style>
